import { render, staticRenderFns } from "./overview1.vue?vue&type=template&id=4cbcb818&scoped=true"
import script from "./overview1.vue?vue&type=script&lang=js"
export * from "./overview1.vue?vue&type=script&lang=js"
import style0 from "./overview1.vue?vue&type=style&index=0&id=4cbcb818&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbcb818",
  null
  
)

export default component.exports